export enum PromotionDiscountRuleType {
    PercentOff = "PercentOff",
    DollarOff = "DollarOff",
    QuantityOff = "QuantityOff",
    Gift = "Gift",
    FlatPrice = "FlatPrice",
}
